/**
 * PhotoPage - Story detail page with modal view
 */

import { useParams, useNavigate } from 'react-router-dom';
import { PhotoDetailModal } from '../components/photos/PhotoDetailModal';
import { Header } from '../components/layout/Header';
import { Footer } from '../components/layout/Footer';
import { useStoryFeed } from '../services/stories';
import { useMemo } from 'react';

export const PhotoPage = () => {
  const { photoId } = useParams<{ photoId: string }>();
  const navigate = useNavigate();
  const { data } = useStoryFeed();

  // Get all stories from the feed
  const stories = useMemo(() => data?.pages.flatMap((page) => page.items) || [], [data]);

  // Find current story index (photoId is actually storyId now)
  const currentIndex = useMemo(
    () => stories.findIndex((story) => story.storyId === photoId),
    [stories, photoId]
  );

  const handleClose = () => {
    navigate('/');
  };

  const handleUserClick = (userId: string) => {
    navigate(`/profile/${userId}`);
  };

  const handleNavigatePrevious = () => {
    if (currentIndex > 0) {
      const prevStoryId = stories[currentIndex - 1].storyId;
      navigate(`/photo/${prevStoryId}`);
    }
  };

  const handleNavigateNext = () => {
    if (currentIndex < stories.length - 1) {
      const nextStoryId = stories[currentIndex + 1].storyId;
      navigate(`/photo/${nextStoryId}`);
    }
  };

  return (
    <div className="flex min-h-dvh flex-col bg-background">
      <Header />

      <main className="flex-1">
        <PhotoDetailModal
          storyId={photoId || null}
          open={!!photoId}
          onOpenChange={(open) => {
            if (!open) handleClose();
          }}
          onUserClick={handleUserClick}
          onNavigatePrevious={handleNavigatePrevious}
          onNavigateNext={handleNavigateNext}
          hasPrevious={currentIndex > 0}
          hasNext={currentIndex >= 0 && currentIndex < stories.length - 1}
        />
      </main>

      <Footer />
    </div>
  );
};
